export const enableAnchorOnComponents = (layoutData) => {
  if (layoutData?.ancora?.id) {
    return {
      id: layoutData?.ancora?.id,
    };
  }
  return null;
};
